RivalIQ.apps.AccountSettings.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const EditName = App.views.Edit.extend({
        template: '#userEditModalTemplate',
        title: 'Edit Name',

        fields: [
            'name'
        ],

        onSaveComplete: function () {
            RivalIQ.execute('alert:info', 'Name Saved');
            RivalIQ.execute('hide:modal');
        }
    });

    const EditEmail = App.views.Edit.extend({
        template: '#userEditModalTemplate',
        title: 'Change Email',

        fields: [
            'email'
        ],

        onSaveComplete: function () {
            RivalIQ.execute('alert:info', 'Email Address Updated');
            RivalIQ.execute('hide:modal');
        }
    });

    const Password = App.views.Edit.extend({
        template: '#userEditModalTemplate',
        title: function () {
            return (RivalIQ.state.user.get('hasSetPassword') ? 'Change Password' : 'Set Password');
        },
        fields: [
            'password'
        ],

        onSaveComplete: function () {
            RivalIQ.execute('alert:info', 'Password Changed');
            RivalIQ.execute('hide:modal');

            RivalIQ.state.user.set('hasSetPassword', true);
        }
    });

    const User = Marionette.ItemView.mixin({
        template: '#userProfileTemplate',

        // unable to set model in initialize function because events don't bind
        model: RivalIQ.state.user,

        events: {
            'click .x-edit-name': 'onEditName',
            'click .x-edit-email': 'onEditEmail',
            'click .x-change-password': 'onChangePassword',
            'click .x-create-api-key': 'onCreateApiKey',
            'click .x-reset-api-key': 'onResetApiKey'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        modelEvents: {
            'sync': 'render',
            'change': 'render'
        },

        templateHelpers: function () {
            const isReadOnly = RivalIQ.state.user.isReadOnly();
            const plan = RivalIQ.state.account.get('plan');
            const isTrialerWithTrialPlan = RivalIQ.state.account.isTrialerWithTrialPlan();

            return {
                canEditEmail: !isTrialerWithTrialPlan,
                hasAnyApiAccess: (plan.has_api_access || plan.has_gds_connector) && !isReadOnly,
                hasSetPassword: RivalIQ.state.user.get('hasSetPassword')
            };
        },

        onEditName: function () {
            const me = this;

            RivalIQ.execute('show:modal', new EditName({
                model: me.model
            }));
        },

        onEditEmail: function () {
            const me = this;

            RivalIQ.execute('show:modal', new EditEmail({
                model: me.model
            }));
        },

        onChangePassword: function () {
            const me = this;

            RivalIQ.execute('show:modal', new Password({
                model: me.model
            }));
        },

        resetApiKey: function (msg) {
            const me = this;
            msg = msg || 'API key reset';

            me.model.resetApiKey()
                .done(function () {
                    RivalIQ.execute('alert:info', msg);
                })
                .fail(function () {
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        },

        onCreateApiKey: function () {
            const me = this;
            me.resetApiKey('API key created');
        },

        onResetApiKey: function () {
            const me = this;
            me.resetApiKey('API key reset');
        }
    });

    widgets.User = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: User,
        viewMore: false,
        exportFormats: [],
        title: RivalIQ.strings.user_widget_title,
        description: RivalIQ.strings.user_widget_description
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.USER, widgets.User);


    const UserProfileManagement = Marionette.ItemView.mixin({
        template: '#userProfileManagementTemplate',

        ui: {
            deleteProfileBtn: '.x-delete-profile-modal'
        },

        events: {
            'click @ui.deleteProfileBtn': 'deleteProfileModal'
        },

        onShow: function () {
            const me = this;

            // NOTE owners of paid/comped accounts cannot delete the account
            const isTrialOrChurned = RivalIQ.state.account.isTrialing() || RivalIQ.state.account.churned();
            const notOwner = !RivalIQ.state.user.isOwner();
            if (isTrialOrChurned || notOwner) {
                me.ui.deleteProfileBtn.removeClass('disabled');
            }
        },

        deleteProfileModal: function () {
            RivalIQ.execute('show:modal', new App.views.DeleteProfileModal({
                model: RivalIQ.state.user
            })
            );
        }

    });

    widgets.UserProfileManagement = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: UserProfileManagement,
        viewMore: false,
        exportFormats: [],
        title: RivalIQ.strings.user_profile_management_widget_title,
        description: RivalIQ.strings.user_profile_management_widget_description
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.USER_PROFILE_MANAGEMENT, widgets.UserProfileManagement);


    App.views.DeleteProfileModal = Marionette.ItemView.extend({
        template: '#deleteProfileModal',
        className: 'modal',
        attributes: {
            tabindex: -1
        },

        ui: {
            deleteBtn: '.x-delete-profile'
        },

        events: {
            'click @ui.deleteBtn': 'deleteProfile'
        },

        templateHelpers: function () {
            return {
                isOwner: RivalIQ.state.user.isOwner()
            };
        },

        deleteProfile: function () {
            const me = this;
            me.ui.deleteBtn.button('loading');

            const result = me.model.deleteProfile();

            if (!result) {
                return me.ui.deleteBtn.button('reset');
            }

            result
                .done(function () {
                    window.location = '/deleteProfileSuccess';
                })
                .fail(function () {
                    me.ui.deleteBtn.button('reset');
                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        }
    });

});
